import { render } from "./AllTeams.vue?vue&type=template&id=bb24675a&scoped=true"
import script from "./AllTeams.vue?vue&type=script&lang=js"
export * from "./AllTeams.vue?vue&type=script&lang=js"

import "./AllTeams.vue?vue&type=style&index=0&id=bb24675a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb24675a"]])

export default __exports__